/**
 * Smooth scroll when opening menu with coverstory in use
 */
function initMenuScrollHelper() {
  let oldScroll = 0;
  let open = false;

  function animateScroll(scrollTop) {
    scroll({
      top: scrollTop,
      behavior: "smooth"
    });
  }

  document.querySelector('.c-menu__hamburger').addEventListener('click', e => {
    e.preventDefault();
    const coverstoryHeight = document.querySelector('.c-menu').offsetTop;
    const currentScroll = window.scrollY;

    if (coverstoryHeight > currentScroll) {
      open = true;
      oldScroll = currentScroll;
      animateScroll(coverstoryHeight);
    } else if (open) {
      open = false;
      animateScroll(oldScroll, 100);
    }
  });
}

const toggleMegaMenu = () => {
  const openMenu = document.querySelector('.c-menu');
  const megaMenu = document.querySelector('.c-menu__mega');
  const mainMenu = document.querySelector('.c-menu__main');
  const burger = document.querySelector('.c-menu__hamburger__wrapper');
  const overlay = document.querySelector('.c-menu__overlay');
  const mobSearch = document.querySelector('.c-menu__search--mob');
  const deskSearch = document.querySelector('.c-menu__search--desk');
  const mainItems = document.querySelector('.c-menu__main-items');
  const secondaryItems = document.querySelector('.c-menu__secondary-items');

  return () => {

    if (secondaryItems) secondaryItems.classList.toggle('c-menu__secondary-items--hidden');
    if (openMenu) openMenu.classList.toggle('c-menu--open');
    if (megaMenu) megaMenu.classList.toggle('c-menu__mega--active');
    if (mainMenu) mainMenu.classList.toggle('c-menu__main--active');
    if (burger) burger.classList.toggle('c-menu__hamburger__wrapper--active');
    if (overlay) overlay.classList.toggle('c-menu__overlay--active');
    if (mobSearch) mobSearch.classList.toggle('c-menu__search--active');
    if (deskSearch) deskSearch.classList.toggle('c-menu__search--active');
    if (mainItems) mainItems.classList.toggle('c-menu__main-items--hidden');

    const isActive = document.querySelector('.c-menu__mega--active');

    if (isActive) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'visible';
    }
  };
};

const toggleSubMenu = (e) => {
  let parentLi = e.target.parentElement.parentElement;

  if (!parentLi.querySelector('.c-menu__mega--child')) {
    parentLi = e.target.parentElement.parentElement.parentElement;
  }

  const subMenu = parentLi.querySelector('.c-menu__mega--child');
  e.currentTarget.classList.toggle('c-menu__title--toggle--active');
  subMenu.classList.toggle('c-menu__mega--collapsed');
  subMenu.classList.toggle('c-menu__mega--visible');
};

// Initiate progressbar and update it on scroll
const initiateProgressBar = () => {
  let timeoutID = null;

  document.addEventListener('scroll', () => {
    const postWrappers = document.querySelectorAll('#content > .o-wrapper');
    let wScroll = window.scrollY;
    const menu = document.querySelector('.c-menu');

    // If menu exists, then we add it to scroll height
    if (typeof menu !== 'undefined') {
      wScroll += menu.offsetHeight;
    }

    for (let i = 0; i < postWrappers.length; i += 1) {
      const postTop = postWrappers[i].offsetTop;
      const postHeight = postWrappers[i].offsetHeight;
      const postBottom = postTop + postHeight;

      // Set progress if this is the active post wrapper
      if (wScroll > postTop && wScroll < postBottom) {
        // Update the progress bar
        updateProgressBar(postTop, postHeight);

        // Clear any previous timeouts
        clearTimeout(timeoutID);

        // Set timeout (this is to prevent a smooth scroll bug)
        timeoutID = setTimeout(updateProgressBar.bind(null, postTop, postHeight), 500);
      }
    }
  });
};

// Update progressbar after scroll
const updateProgressBar = (postTop, postHeight) => {
  let wScroll = window.scrollY;
  const menu = document.querySelector('.c-menu');
  if (typeof menu !== 'undefined') {
    // If menu exists, then we add it to scroll height
    wScroll += menu.offsetHeight;
  }
  const wHeight = document.documentElement.clientHeight;
  const scrollTop = wScroll - postTop;
  const scrollBottom = postHeight - wHeight;
  let scrollPercent = (scrollTop / scrollBottom) * 100;

  // Prevent tiny progress
  if (scrollPercent < 0.5) {
    scrollPercent = 0;
  } else if (scrollPercent > 99.5) {
    scrollPercent = 100;
  }

  // Set width of progress bar to match
  document.querySelector('.c-menu__progress > span').style.setProperty('width', `${scrollPercent}%`);
};

// Open menu and focus on search input
const openSearch = () => {
  let visibleSearch = document.querySelector('.c-menu__search--desk');
  const toggleMenu = toggleMegaMenu();

  // Open mega menu
  toggleMenu();

  // Check which search is visible and should be used
  if (window.getComputedStyle(visibleSearch, null).display === 'none') {
    visibleSearch = document.querySelector('.c-menu__search--mob');
  }

  // Find input inside visible search and focus on it
  let searchInput = visibleSearch.getElementsByClassName('c-menu__search-container')[0];
  searchInput = searchInput.getElementsByTagName('input')[0];
  searchInput.focus();
}

const init = () => {
  const menuBtn = document.querySelector('.c-menu__hamburger');
  const subMenuBtns = document.querySelectorAll('.c-menu__title--toggle');
  const trendingRow = document.querySelector('.c-menu__trending');
  const progressBar = document.querySelector('.c-menu__progress');
  const searchBtn = document.querySelector('.c-menu__search-button');
  const mobSearch = document.querySelector('.c-menu__search--mob');
  const deskSearch = document.querySelector('.c-menu__search--desk');

  if (!trendingRow) {
    document.body.classList.add('no-trending');
  }

  menuBtn.addEventListener('click', toggleMegaMenu());

  Array.from(subMenuBtns, (btn) => {
    btn.addEventListener('click', toggleSubMenu);
  });

  if (progressBar) initiateProgressBar();
  if (searchBtn) searchBtn.addEventListener('click', openSearch);

  // Show/hide menu overlay on focus & blur on search input
  [mobSearch, deskSearch].forEach((s) => {
    let input = s.getElementsByClassName('c-menu__search-container')[0];
    input = input.getElementsByTagName('input')[0];
    const overlay = s.getElementsByClassName('c-menu__search__overlay')[0];
    const closeSearch = s.getElementsByClassName('c-menu__search__close')[0];

    ['focus', 'blur'].forEach((e) => {
      input.addEventListener(e, () => {
        overlay.classList.toggle('c-menu__search__overlay--visible');

        if (closeSearch) {
          closeSearch.classList.toggle('c-menu__search__close--visible');
        }
      });
    });
  });
};

export default {
  init,
  initMenuScrollHelper,
};
